import React from 'react'
import ProductList from '../components/Products/ProductList'

const ProductScreen = () => {
  return (
    <ProductList/>
  )
}

export default ProductScreen